export type NameState = {draft:string;saved:string;busy:boolean;error:string};
/** One owner/session-scoped serial queue; route teardown flushes, never discards. */
export function createNameAutosave(initial:string, active:()=>boolean, persist:(name:string)=>Promise<void>, notifyError:(message:string)=>void) {
  let state:NameState={draft:initial,saved:initial,busy:false,error:''};
  let timer:ReturnType<typeof setTimeout>|undefined,flight:Promise<void>|undefined;
  const listeners=new Set<()=>void>();
  const emit=(patch:Partial<NameState>)=>{state={...state,...patch};listeners.forEach(fn=>fn())};
  const flush=():Promise<void>=>{
    clearTimeout(timer);
    if(flight)return flight;
    if(!active()||state.draft===state.saved)return Promise.resolve();
    flight=Promise.resolve().then(async()=>{
      emit({busy:true,error:''});
      try {
        while(active()&&state.draft!==state.saved){
          const value=state.draft.trim();
          if(!value||value.length>64)throw Error('Введите имя от 1 до 64 символов');
          await persist(value);
          if(!active())return;
          const unchanged=state.draft.trim()===value;
          emit({saved:value,...(unchanged?{draft:value}:{})});
        }
      }catch(e){if(active()){const error=e instanceof Error?e.message:'Не удалось сохранить имя';emit({error});notifyError(error)}throw e}
      finally{emit({busy:false});flight=undefined}
    });
    return flight;
  };
  return {
    snapshot:()=>state,
    subscribe:(fn:()=>void)=>{listeners.add(fn);return()=>{listeners.delete(fn)}},
    edit:(draft:string)=>{if(!active())return;emit({draft,error:''});clearTimeout(timer);timer=setTimeout(()=>{void flush().catch(()=>{})},600)},
    flush,
    discard:()=>{if(state.busy)return;clearTimeout(timer);emit({draft:state.saved,error:''})},
  };
}
